import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import type { AxiosError } from "axios";

/**
 * tailwind-merge ciente da escala tipográfica do design system (index.css @theme):
 * sem isso, `text-caption` e `text-fg-muted` seriam vistos como duas cores e um sumiria.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["overline", "caption", "body-sm", "body", "title-sm", "title", "title-lg", "kpi", "kpi-lg"] }],
      shadow: [{ shadow: ["xs", "sm", "md", "lg"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Duração em ms → "HH:MM:SS"; "00:00:00" para vazio ou ≤ 0 (GUI formatDurationMS). */
export function formatDurationMS(durationMS?: number | null): string {
  if (durationMS === undefined || durationMS === null || Number.isNaN(durationMS) || durationMS <= 0) {
    return "00:00:00";
  }
  let dt = Math.floor(durationMS / 1000);
  const seconds = dt % 60;
  dt = Math.floor(dt / 60);
  const minutes = dt % 60;
  const hours = Math.floor(dt / 60);
  return [hours, minutes, seconds].map((n) => String(n).padStart(2, "0")).join(":");
}

export function formatStatus(status: string): string {
  const parts = status.split(".");
  return parts.length > 1 ? parts[1] : status;
}

/** Senha numérica de N dígitos para novo usuário (exibida uma única vez na UI). */
export function generateNumericPassword(length = 8): string {
  let out = "";
  for (let i = 0; i < length; i++) {
    out += String(Math.floor(Math.random() * 10));
  }
  return out;
}

export function getApiErrorMessage(error: unknown, fallback = "Não foi possível concluir a operação."): string {
  if (error && typeof error === "object" && "isAxiosError" in error && (error as AxiosError).isAxiosError) {
    const ax = error as AxiosError<{ message?: string; error?: string } | string>;
    const data = ax.response?.data;
    if (typeof data === "string" && data.length > 0) return data;
    if (data && typeof data === "object") {
      if (data.message) return data.message;
      if (data.error) return data.error;
    }
    if (ax.response?.status === 403) return "Sem permissão para esta operação.";
    if (ax.response?.status === 404) return "Registro não encontrado.";
    if (ax.response?.status === 400) return "Dados inválidos. Verifique os campos.";
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
